const slugify = (value) =>
	value
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/(^-|-$)/g, "");

const getProjectSlug = (project) => project.slug || slugify(project.title);

const getProjectPath = (project) => `/projects/${getProjectSlug(project)}`;

const getProjectBySlug = (projects, slug) =>
	projects.find((project) => getProjectSlug(project) === slug);

export { getProjectBySlug, getProjectPath, getProjectSlug, slugify };
